import Choices from 'choices.js';

const handleSelect = (select) => {
  const choices = new Choices(select, {
    removeItemButton: true,
    itemSelectText: '',
    position: 'bottom',
    placeholder: true,
    placeholderValue: 'aaa',
    classNames: {
      containerOuter: 'select',
      containerInner: 'select__inner',
      input: 'select__input',
      inputCloned: 'select__input_cloned',
      list: 'select__list',
      listItems: 'select__list_multiple',
      listSingle: 'select__list_single',
      listDropdown: 'select__list_dropdown',
      item: 'select__item',
      itemSelectable: 'select__item_selectable',
      itemDisabled: 'select__item_disabled',
      itemOption: 'select__item_choice',
      group: 'select__group',
      groupHeading: 'select__heading',
      button: 'select__button',
      activeState: 'active',
      focusState: 'focused',
      openState: 'open',
      disabledState: 'disabled',
      highlightedState: 'highlighted',
      selectedState: 'selected',
      flippedState: 'flipped',
      selectedState: 'highlighted',
      loadingState: 'is-loading',
      noResults: 'has-no-results',
      noChoices: 'has-no-choices',
    },
  });

  return choices;
};

export default handleSelect;
